import Bowser from "bowser";
import { LobbyDevice, RendererConstants, RendererDevice, } from "../../game/renderer/constant/RendererConstants";
import { WebUtil } from "../web/WebUtil";
export class DeviceUtil {
    /*
     * Returns the device for the renderer and what assets to load e.g phone or tablet
     */
    static getRendererDevice() {
        const bowser = Bowser.getParser(window.navigator.userAgent);
        let forceDevice = WebUtil.getUrlParameter(RendererConstants.PROPERTY_FORCE_DEVICE);
        let valid = forceDevice == "phone" || forceDevice == "tablet";
        if (valid && forceDevice) {
            return forceDevice;
        }
        else {
            return bowser.getPlatformType(true) === "mobile"
                ? RendererDevice.PHONE
                : RendererDevice.TABLET;
        }
    }
    /*
     * Returns the deviceType for lobby listings e.g MOBILE_WEB or DESKTOP_WEB
     * used to initialise the API.
     */
    static getDeviceType() {
        const bowser = Bowser.getParser(window.navigator.userAgent);
        const platformType = bowser.getPlatformType();
        return platformType === "mobile" || platformType === "tablet"
            ? LobbyDevice.MOBILE_WEB
            : LobbyDevice.DESKTOP;
    }
    /*
     * Return is the device is touch
     */
    static isTouch() {
        const bowser = Bowser.getParser(window.navigator.userAgent);
        const platformType = bowser.getPlatformType();
        const isMac = bowser.getOSName() === Bowser.OS_MAP.MacOS;
        const isSafari = bowser.getBrowserName() === Bowser.BROWSER_MAP.safari;
        const isIpad = navigator.userAgent.includes("Mac") && "ontouchend" in document;
        return (platformType === "mobile" ||
            platformType === "tablet" ||
            (isMac && isSafari && navigator.maxTouchPoints > 1) ||
            isIpad);
    }
    /**
     * @returns `true` if device is iOS
     */
    static isIos() {
        const bowser = Bowser.getParser(window.navigator.userAgent);
        const isIOS = bowser.getOSName() === Bowser.OS_MAP.iOS;
        const isMac = bowser.getOSName() === Bowser.OS_MAP.MacOS;
        const isSafari = bowser.getBrowserName() === Bowser.BROWSER_MAP.safari;
        return isIOS || (isMac && isSafari && navigator.maxTouchPoints > 1);
    }
    /**
     * @returns `true` if current browser is safari
     */
    static isBrowserSafari() {
        const bowser = Bowser.getParser(window.navigator.userAgent);
        return bowser.getBrowserName() === Bowser.BROWSER_MAP.safari;
    }
    /**
     * @returns `true` if current browser is the samsung bundled browser
     */
    static isBrowserSamsung() {
        const bowser = Bowser.getParser(window.navigator.userAgent);
        return bowser.getBrowserName() === Bowser.BROWSER_MAP.samsung_internet;
    }
}
//# sourceMappingURL=DeviceUtil.js.map